import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const COUNTRY_URL = APIURL+"/location/countries/";

// CREATE =>  POST: create a new country to the server
export function createCountry(country) {
	const result = axios.post(`${COUNTRY_URL}create`, country);
	return result
}

// READ
export function getAllCountries() {
  return axios.get(COUNTRY_URL);
}

export function getCountryById(countryId) {
	const result = axios.get(`${COUNTRY_URL}find/${countryId}`);
	return result;
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCountries(queryParams) {
  const result = axios.post(`${COUNTRY_URL}find`, { queryParams });
  return result;
}

// UPDATE => PUT: update the country on the server
export function updateCountry(country) {
  return axios.post(`${COUNTRY_URL}update/${country.id}`, { country });
}

// UPDATE Status
export function updateStatusForCountries(ids, status) {
  return axios.post(`${COUNTRY_URL}updateStatusForCountries`, {
    ids,
    status
  });
}

// UPDATE single Status
export function updateStatusForCountry(id, status) {
  return axios.post(`${COUNTRY_URL}updateStatusForCountry`, {
    id,
    status
  });
}

export function createCountryByName(name) {
  return axios.post(`${COUNTRY_URL}create`, {
    name
  });
}

export function updateRecordForCountry(id,name) {
  return axios.post(`${COUNTRY_URL}updateRecordForCountry`, { id, name});
}

// DELETE => delete the country from the server
export function deleteCountry(id) {
 return axios.post(`${COUNTRY_URL}delete`, { id });
}

// DELETE Countries by ids
export function deleteCountries(ids) {
  return axios.post(`${COUNTRY_URL}deleteCountries`, { ids });
}
